module.exports = __webpack_public_path__ + "assets/img/behaviorAnalysis-active.384eec04.svg";